<template>
    <div class="card">
        <b>Instruction</b>

        <ol class="instruction">
            <li>
                Ensure participant has successfully completed PAR-Q Exercise Questionnaire confirming there are no
                medical contraindications before performing the test.
            </li>
            <li>
                Before starting the test check the Pre-Test Conditions.
            </li>
            <li>
                Enter the details of the participant: name, age and sex are required fields.
            </li>
            <li>
                Select the step height to be used by the participant
            </li>
            <li>
                Following a suitable loosening and limbering warmup, conduct the test according to the audio track
                instructions, recording heart rate every minute and RPE at the end of each 2-minute Level.
            </li>
            <li>
                At the end of each Level, providing heart rate is below 80% HRMax and RPE is below 14, then proceed to the next Level.
            </li>
            <li>
                The test ends when the participant reaches 80% HRMax or an RPE of 14 or more. If 80% HRMax is reached mid-Level, then providing there are no signs of distress or discomfort, the test may be normally continued to the end of the 1-minute stage.
            </li>
            <li>
                If at any time during the test, the subject shows signs of being over-tired, breathless or dizzy, please stop the test and allow the subject to cool down and recover.
            </li>
            <li>
                On completion of the test, ensure the participant cools down with some gently limbering and stretching exercises.
            </li>
            <li>
                When the heart rate data has been entered, calculate the participant's aerobic capacity by clicking on the Calculate button.
            </li>
        </ol>
    </div>
</template>

<script setup>

import { computed, defineProps, onMounted, ref } from 'vue';
import GlobalRequest from '@/api/global-request';
import { showToast } from '@/helpers/toast-handler';
import { useStore } from 'vuex';

const store = useStore();

const props = defineProps({
    id: {
        type: [Number, String],
        required: true,
    },
});

const user = ref({})

const company_id = computed(() => {
    return store.getters['auth/userCompanyId']?.id;
});

onMounted(() => {

    console.log('props.id', props.id)

    GlobalRequest
        .getRequest(`/v2/user_profile/last?user_id=${props.id}`)
        .then((response) => {
            console.log('profile response', response)
        })

    GlobalRequest
        .getRequest(`v2/admin/users/${props.id}?company_id=${company_id.value}`)
        .then((response) => {
            console.log('response', response)
            user.value = {}
            if (response.statusCode === 200) {
                if (Object.hasOwn(response, 'data')) {
                    user.value = response.data
                }
            }
        }).catch((err) => {
            console.error(err)
        showToast({}, err?.data?.message ?? 'Something went wrong');
    });
});
</script>

<style scoped lang="scss">
.instruction li {
    font-size: 13px;
    line-height: 1.5;
}
</style>